import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {EntityHeader} from '../../entity/entity-header';
import {EntityLineHeader} from '../../entity/entity-line-header';
import {QuoteService} from '../../services/quote-service';
import {StringUtils} from '../../utils/string-utils';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogRef} from '@angular/material/dialog';
import {EntityKeyUtils} from '../../utils/entity-key-utils';
import {MatButton} from '@angular/material/button';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

import {EntitySearchComponent} from '../../entity/entity-search.component';

@Component({
    selector: 'copy-lines-dialog',
    templateUrl: './copy-lines-dialog.component.html',
    styleUrls: ['./copy-lines-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EntitySearchComponent, MatProgressSpinner, MatDialogActions, MatButton]
})
export class CopyLinesDialogComponent {
  private readonly quoteService = inject(QuoteService);
  readonly dialogRef = inject<MatDialogRef<CopyLinesDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  public lines: EntityLineHeader[];
  public entityName: string = "QUOTE";
  public readonly errorMessage = signal<string>(undefined!);
  public readonly isBusy = signal<boolean>(undefined!);
  public selectedQuote!: EntityHeader;

  constructor
  () {
    const data = this.data;

    this.lines = data.lines as EntityLineHeader[];
  }

  public setSelected(entityHeader: EntityHeader) {
    this.selectedQuote = entityHeader;
  }

  public saveAndClose(): void {
    this.isBusy.set(true);
    this.quoteService.copyLines(EntityKeyUtils.convertToFlatEntityKey(this.selectedQuote.id), this.lines).subscribe(response => this.dialogRef.close(response.updated), error => this.handleError(error));
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  public newQuote(): void {
    this.isBusy.set(true);
    this.quoteService.createAndCopyLines(this.lines).subscribe(response => this.dialogRef.close(response.updated), error => this.handleError(error));
  }

}
